"use client";

import { c as _c } from "react/compiler-runtime";
import { Check, Close, LocationPin } from "@mui/icons-material";
import { SwipeableDrawer } from "@mui/material";
import Image from "next/image";
import { useRouter } from "next/navigation";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { Breadcrumb, Button, ButtonVariant, Text, TextColor, TextSize, TextVariant, TextWeight } from "../../components";
import { useMatchBreakpoints } from "../../hooks";
// Types

import { extractColor, extractSize } from "../../utils";
import { FeaturedProducts } from "../FeaturedProducts/FeaturedProducts";
import { ProductGallery } from "../ProductGallery/ProductGallery";
import { ProductMiniature } from "../ProductMiniature";
const useProductVariants = product => {
  const $ = _c(8);
  const [selectedVariant, setSelectedVariant] = useState(null);
  let t0;
  let t1;
  if ($[0] !== product.combinations?.values) {
    const colorMap = new Map();
    product.combinations?.values.forEach(combination => {
      const color = combination.attributes.Kolor;
      if (!colorMap.has(color)) {
        colorMap.set(color, {
          name: color,
          combination
        });
      }
    });
    t1 = Array.from(colorMap.values());
    $[0] = product.combinations?.values;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  t0 = t1;
  const colors = t0;
  let t2;
  if ($[2] !== product.combinations?.values) {
    t2 = color_0 => product.combinations?.values.filter(combination_0 => combination_0.attributes.Kolor === color_0).map(_temp) || [];
    $[2] = product.combinations?.values;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getSizesForColor = t2;
  let t3;
  if ($[4] !== colors || $[5] !== getSizesForColor || $[6] !== selectedVariant) {
    t3 = {
      colors,
      getSizesForColor,
      selectedVariant,
      setSelectedVariant
    };
    $[4] = colors;
    $[5] = getSizesForColor;
    $[6] = selectedVariant;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
const ProductVariants = t0 => {
  const $ = _c(15);
  const {
    colors,
    productColor,
    selectedColor,
    onColorChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Text text="Kolor" fontSize={TextSize.S} weight={TextWeight.BOLD} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== productColor) {
    t2 = <Text text={productColor} fontSize={TextSize.S} color={TextColor.GRAYSCALE_600} />;
    $[1] = productColor;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== colors || $[4] !== onColorChange || $[5] !== selectedColor) {
    let t4;
    if ($[7] !== onColorChange || $[8] !== selectedColor) {
      t4 = color => <div key={color.name} className={`w-12 h-16 border-2 cursor-pointer hover:border-gray-500 ${selectedColor === color.name ? "border-black" : "border-gray-300"}`} onClick={() => onColorChange(color.combination.reference)}>{color.combination.cover?.url && <Image src={color.combination.cover.url.replace("http://localhost/prestashop", "https://shop.carry.pl").replace("carry-prestashop.ulam.tech", "shop.carry.pl")} alt={`Kolor ${color.name}`} width={48} height={64} className="w-full h-full object-cover" />}</div>;
      $[7] = onColorChange;
      $[8] = selectedColor;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t3 = colors.map(t4);
    $[3] = colors;
    $[4] = onColorChange;
    $[5] = selectedColor;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <div className="grid grid-cols-[repeat(auto-fit,minmax(48px,48px))] gap-2">{t3}</div>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t4) {
    t5 = <div className="flex flex-col gap-2 my-8">{t1}{t2}{t4}</div>;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
const ProductSizes = t0 => {
  const $ = _c(17);
  const {
    sizes,
    selectedSize,
    onSizeChange,
    setSelectedIdProductAttribute,
    isLoading: t1,
    errorNoSizeSelected: t2
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const errorNoSizeSelected = t2 === undefined ? false : t2;
  const t3 = errorNoSizeSelected ? TextColor.ERROR_500 : TextColor.GRAYSCALE_900;
  let t4;
  if ($[0] !== t3) {
    t4 = <Text text="Rozmiary" fontSize={TextSize.S} weight={TextWeight.BOLD} color={t3} />;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== errorNoSizeSelected || $[3] !== isLoading || $[4] !== onSizeChange || $[5] !== selectedSize || $[6] !== setSelectedIdProductAttribute || $[7] !== sizes) {
    t5 = isLoading ? Array.from({
      length: 5
    }).map(_temp2) : sizes.map(sizeVariant => {
      const isSelected = selectedSize === sizeVariant.size;
      const isAvailable = sizeVariant.quantity > 0;
      return <div key={sizeVariant.idProductAttribute} className={`
               w-12 h-10 flex items-center justify-center border cursor-pointer
               ${isSelected ? "border-black bg-black text-white" : "border-gray-300 hover:border-gray-500"}
               ${!isAvailable ? "opacity-20 cursor-not-allowed" : ""}
               ${errorNoSizeSelected && isAvailable ? "!bg-red-50 animate-pulse" : ""}
             `} onClick={() => {
        if (isAvailable) {
          onSizeChange(sizeVariant.size || "", sizeVariant.reference || "");
          setSelectedIdProductAttribute(Number(sizeVariant.idProductAttribute));
        }
      }}><StyledSizeText text={sizeVariant.size || ""} fontSize={TextSize.XS} color={isSelected ? TextColor.WHITE : TextColor.GRAYSCALE_900} /></div>;
    });
    $[2] = errorNoSizeSelected;
    $[3] = isLoading;
    $[4] = onSizeChange;
    $[5] = selectedSize;
    $[6] = setSelectedIdProductAttribute;
    $[7] = sizes;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <div className="flex gap-2 flex-wrap ">{t5}</div>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== errorNoSizeSelected) {
    t7 = errorNoSizeSelected && <Text text={"Prosz\u0119 wybra\u0107 rozmiar"} fontSize={TextSize.XS} color={TextColor.ERROR_500} />;
    $[11] = errorNoSizeSelected;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t4 || $[14] !== t6 || $[15] !== t7) {
    t8 = <div className="flex flex-col gap-2">{t4}{t6}{t7}</div>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
const StyledSizeText = styled(Text)`
  p {
    text-align: center !important;
    line-height: 100% !important;
    font-size: ${({
  theme
}) => theme.fontSizes.s} !important;
  }
`;
export const ProductPage = t0 => {
  const $ = _c(171);
  const {
    product,
    getProductData,
    updateCart,
    openUpdateCartModal,
    toggleUpdateCartModal,
    addedProduct,
    parentCategory,
    shopAvailabilityDrawer,
    openShopAvailabilityDrawer,
    setOpenShopAvailabilityDrawer,
    sizeTableDrawer,
    openSizeTableDrawer,
    setOpenSizeTableDrawer,
    accessories,
    loadingAccessories,
    featuredProducts,
    loadingFeaturedProducts,
    isProductLoading: t1
  } = t0;
  const isProductLoading = t1 === undefined ? false : t1;
  const [errorNoSizeSelected, setErrorNoSizeSelected] = useState(false);
  const {
    colors,
    getSizesForColor
  } = useProductVariants(product);
  let t2;
  if ($[0] !== colors || $[1] !== product.color) {
    t2 = () => product.color || colors[0]?.name || "";
    $[0] = colors;
    $[1] = product.color;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [selectedColor, setSelectedColor] = useState(t2);
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedIdProductAttribute, setSelectedIdProductAttribute] = useState(null);
  const {
    isXs,
    isSm,
    isMd
  } = useMatchBreakpoints();
  const isMobile = isXs || isSm || isMd;
  const router = useRouter();
  const discounted = product.discountPrice && product.discountPrice !== product.regularPrice;
  let t3;
  if ($[3] !== getSizesForColor || $[4] !== selectedColor) {
    t3 = getSizesForColor(selectedColor);
    $[3] = getSizesForColor;
    $[4] = selectedColor;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const availableSizes = t3;
  let t4;
  if ($[6] !== getProductData || $[7] !== product.combinations?.values) {
    t4 = reference => {
      const selectedCombination = product.combinations?.values.find(combo => combo.reference === reference);
      if (selectedCombination) {
        const newColor = selectedCombination.attributes.Kolor;
        setSelectedColor(newColor);
        setSelectedSize("");
      }
      getProductData(reference);
    };
    $[6] = getProductData;
    $[7] = product.combinations?.values;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleColorChange = t4;
  let t5;
  let t6;
  if ($[9] !== colors || $[10] !== selectedColor) {
    t5 = () => {
      if (!selectedColor && colors.length > 0) {
        setSelectedColor(colors[0].name);
      }
    };
    t6 = [colors, selectedColor];
    $[9] = colors;
    $[10] = selectedColor;
    $[11] = t5;
    $[12] = t6;
  } else {
    t5 = $[11];
    t6 = $[12];
  }
  useEffect(t5, t6);
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      title: "Strona g\u0142\xF3wna",
      slug: "/"
    };
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== parentCategory.linkRewrite || $[15] !== parentCategory.name) {
    t8 = {
      title: parentCategory.name,
      slug: parentCategory.linkRewrite
    };
    $[14] = parentCategory.linkRewrite;
    $[15] = parentCategory.name;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = product.categoryInfo?.name || "";
  const t10 = product.categoryInfo?.linkRewrite || "";
  let t11;
  if ($[17] !== t10 || $[18] !== t9) {
    t11 = {
      title: t9,
      slug: t10
    };
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t8) {
    t12 = <div className="flex justify-center w-full mt-8 md:mt-0"><Breadcrumb breadcrumbs={[t7, t8, t11]} /></div>;
    $[20] = t11;
    $[21] = t8;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== product.images) {
    t13 = product.images || [];
    $[23] = product.images;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t13) {
    t14 = <div className="col-span-1 lg:col-span-8"><ProductGallery images={t13} /></div>;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== product.labels) {
    t15 = product.labels && product.labels.length > 0 && <div className="flex gap-2 mb-4">{product.labels?.map(_temp3)}</div>;
    $[27] = product.labels;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== isProductLoading || $[30] !== product.name) {
    t16 = isProductLoading ? <div className="h-6 w-2/4 bg-gray-200 animate-pulse" /> : <Text text={product.name} variant={TextVariant.H1} weight={TextWeight.BOLD} fontSize={TextSize.L} textTransform="uppercase" />;
    $[29] = isProductLoading;
    $[30] = product.name;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Text text="Indeks:" fontSize={TextSize.XS} weight={TextWeight.BOLD} />;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== isProductLoading || $[34] !== product.reference) {
    t18 = <div className="flex gap-1 my-2">{t17}{isProductLoading ? <div className="h-4 w-24 bg-gray-200 animate-pulse" /> : <Text text={product.reference} fontSize={TextSize.XS} />}</div>;
    $[33] = isProductLoading;
    $[34] = product.reference;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  const t19 = discounted ? TextSize.S : TextSize.XL;
  const t20 = discounted ? TextColor.GRAYSCALE_700 : TextColor.GRAYSCALE_900;
  const t21 = discounted ? "line-through" : "none";
  let t22;
  if ($[36] !== product.regularPrice || $[37] !== t19 || $[38] !== t20 || $[39] !== t21) {
    t22 = <Text text={product.regularPrice} fontSize={t19} weight={TextWeight.BOLD} color={t20} textDecoration={t21} />;
    $[36] = product.regularPrice;
    $[37] = t19;
    $[38] = t20;
    $[39] = t21;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== discounted || $[42] !== product.discountPrice) {
    t23 = discounted && <Text text={product.discountPrice} fontSize={TextSize.XL} weight={TextWeight.BOLD} color={TextColor.ERROR_600} />;
    $[41] = discounted;
    $[42] = product.discountPrice;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== t22 || $[45] !== t23) {
    t24 = <div className="flex items-end gap-2">{t22}{t23}</div>;
    $[44] = t22;
    $[45] = t23;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== discounted || $[48] !== product.lowestPrice) {
    t25 = discounted && <Text text={`Najniższa cena z 30 dni przed obniżką: ${product.lowestPrice}`} fontSize={TextSize.XXS} color={TextColor.GRAYSCALE_400} />;
    $[47] = discounted;
    $[48] = product.lowestPrice;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] !== t24 || $[51] !== t25) {
    t26 = <StyledPriceWrapper className="flex flex-col gap-2 my-4">{t24}{t25}</StyledPriceWrapper>;
    $[50] = t24;
    $[51] = t25;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  const t27 = product.color || "";
  let t28;
  if ($[53] !== colors || $[54] !== handleColorChange || $[55] !== selectedColor || $[56] !== t27) {
    t28 = <ProductVariants productColor={t27} colors={colors} selectedColor={selectedColor} onColorChange={handleColorChange} />;
    $[53] = colors;
    $[54] = handleColorChange;
    $[55] = selectedColor;
    $[56] = t27;
    $[57] = t28;
  } else {
    t28 = $[57];
  }
  const t29 = availableSizes;
  let t30;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = size => setSelectedSize(size);
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== errorNoSizeSelected || $[60] !== isProductLoading || $[61] !== selectedSize || $[62] !== t29) {
    t31 = <ProductSizes sizes={t29} selectedSize={selectedSize} onSizeChange={t30} setSelectedIdProductAttribute={setSelectedIdProductAttribute} isLoading={isProductLoading} errorNoSizeSelected={errorNoSizeSelected} />;
    $[59] = errorNoSizeSelected;
    $[60] = isProductLoading;
    $[61] = selectedSize;
    $[62] = t29;
    $[63] = t31;
  } else {
    t31 = $[63];
  }
  let t32;
  if ($[64] !== setOpenSizeTableDrawer || $[65] !== sizeTableDrawer) {
    t32 = sizeTableDrawer && <Text text="Wymiary tego produktu" fontSize={TextSize.XS} color={TextColor.GRAYSCALE_400} textDecoration="underline" className="cursor-pointer" onClick={() => setOpenSizeTableDrawer(true)} />;
    $[64] = setOpenSizeTableDrawer;
    $[65] = sizeTableDrawer;
    $[66] = t32;
  } else {
    t32 = $[66];
  }
  let t33;
  if ($[67] !== t31 || $[68] !== t32) {
    t33 = <div className="flex flex-col gap-2 mb-8">{t31}{t32}</div>;
    $[67] = t31;
    $[68] = t32;
    $[69] = t33;
  } else {
    t33 = $[69];
  }
  let t34;
  if ($[70] !== availableSizes || $[71] !== product.id || $[72] !== selectedIdProductAttribute || $[73] !== selectedSize || $[74] !== updateCart) {
    t34 = availableSizes.some(_temp4) ? <div onClick={() => {
      if (selectedSize === "" || selectedIdProductAttribute === null) {
        setErrorNoSizeSelected(true);
        setTimeout(() => {
          setErrorNoSizeSelected(false);
        }, 5000);
      }
    }}><Button text="Dodaj do koszyka" className="!w-full md:!w-[350px]" disabled={selectedSize === "" || selectedIdProductAttribute === null} onClick={() => {
        updateCart(Number(product.id) || 0, selectedIdProductAttribute || 0, 1, "up");
      }} /></div> : <Text text={"Brak dost\u0119pnych rozmiar\xF3w, sprawd\u017A dost\u0119pno\u015B\u0107 w sklepach stacjonarnych"} fontSize={TextSize.XS} color={TextColor.GRAYSCALE_400} className="border border-gray-300 p-2 text-center" />;
    $[70] = availableSizes;
    $[71] = product.id;
    $[72] = selectedIdProductAttribute;
    $[73] = selectedSize;
    $[74] = updateCart;
    $[75] = t34;
  } else {
    t34 = $[75];
  }
  let t35;
  if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <LocationPin className="w-4 h-4 text-gray-600" />;
    $[76] = t35;
  } else {
    t35 = $[76];
  }
  let t36;
  if ($[77] !== setOpenShopAvailabilityDrawer) {
    t36 = <div className="flex items-center gap-2 my-4">{t35}<Text text={"Sprawd\u017A dost\u0119pno\u015B\u0107 w sklepach stacjonarnych"} fontSize={TextSize.S} color={TextColor.GRAYSCALE_600} textDecoration="underline" className="cursor-pointer mt-1" onClick={() => setOpenShopAvailabilityDrawer(true)} /></div>;
    $[77] = setOpenShopAvailabilityDrawer;
    $[78] = t36;
  } else {
    t36 = $[78];
  }
  const t37 = !isMobile;
  const t38 = isMobile ? TextSize.XS : TextSize.S;
  let t39;
  if ($[79] !== t38) {
    t39 = <Text text={"Wysy\u0142ka 1-3 dni robocze"} fontSize={t38} color={TextColor.GRAYSCALE_600} />;
    $[79] = t38;
    $[80] = t39;
  } else {
    t39 = $[80];
  }
  let t40;
  if ($[81] !== t37 || $[82] !== t39) {
    t40 = <CopyWrapper $after={t37} $before={true} className="flex items-center justify-start md:justify-center gap-2 py-4 md:p-4 md:px-6 md:text-center">{t39}</CopyWrapper>;
    $[81] = t37;
    $[82] = t39;
    $[83] = t40;
  } else {
    t40 = $[83];
  }
  const t41 = isMobile ? TextSize.XS : TextSize.S;
  let t42;
  if ($[84] !== t41) {
    t42 = <CopyWrapper $before={true} className="flex items-center justify-start md:justify-center gap-2 py-4 md:p-4 md:px-6 md:text-center"><Text text={"Wybrana darmowa dostawa od 150 z\u0142"} fontSize={t41} color={TextColor.GRAYSCALE_600} /></CopyWrapper>;
    $[84] = t41;
    $[85] = t42;
  } else {
    t42 = $[85];
  }
  const t43 = !isMobile;
  const t44 = isMobile ? TextSize.XS : TextSize.S;
  let t45;
  if ($[86] !== t44) {
    t45 = <Text text="30 dni na zwrot produktu" fontSize={t44} color={TextColor.GRAYSCALE_600} />;
    $[86] = t44;
    $[87] = t45;
  } else {
    t45 = $[87];
  }
  let t46;
  if ($[88] !== isMobile || $[89] !== t43 || $[90] !== t45) {
    t46 = <CopyWrapper $after={t43} $before={isMobile} className="flex items-center justify-start md:justify-center gap-2 py-4 md:p-4 md:px-6 md:text-center">{t45}</CopyWrapper>;
    $[88] = isMobile;
    $[89] = t43;
    $[90] = t45;
    $[91] = t46;
  } else {
    t46 = $[91];
  }
  const t47 = isMobile ? TextSize.XS : TextSize.S;
  let t48;
  if ($[92] !== t47) {
    t48 = <CopyWrapper className="flex items-center justify-start md:justify-center gap-2 py-4 md:p-4 md:px-6 md:text-center"><Text text={"Zwroty od 7,99 z\u0142 dla os\xF3b zapisanych do newslettera"} fontSize={t47} color={TextColor.GRAYSCALE_600} /></CopyWrapper>;
    $[92] = t47;
    $[93] = t48;
  } else {
    t48 = $[93];
  }
  let t49;
  if ($[94] !== t40 || $[95] !== t42 || $[96] !== t46 || $[97] !== t48) {
    t49 = <div className="grid grid-cols-1 md:grid-cols-2">{t40}{t42}{t46}{t48}</div>;
    $[94] = t40;
    $[95] = t42;
    $[96] = t46;
    $[97] = t48;
    $[98] = t49;
  } else {
    t49 = $[98];
  }
  let t50;
  if ($[99] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = <Text text="Opis produktu" weight={TextWeight.BOLD} fontSize={TextSize.M} />;
    $[99] = t50;
  } else {
    t50 = $[99];
  }
  let t51;
  if ($[100] !== product.description) {
    t51 = <div className="flex flex-col gap-2 mt-8 mb-4">{t50}<FormattedDescription textHtml={product.description} /></div>;
    $[100] = product.description;
    $[101] = t51;
  } else {
    t51 = $[101];
  }
  let t52;
  if ($[102] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <Text text={"Sk\u0142ad"} weight={TextWeight.BOLD} fontSize={TextSize.M} />;
    $[102] = t52;
  } else {
    t52 = $[102];
  }
  let t53;
  if ($[103] !== product.descriptionShort) {
    t53 = <div className="flex flex-col gap-2 mt-8 mb-4">{t52}<Text textHtml={product.descriptionShort} fontSize={TextSize.XS} color={TextColor.GRAYSCALE_600} /></div>;
    $[103] = product.descriptionShort;
    $[104] = t53;
  } else {
    t53 = $[104];
  }
  let t54;
  if ($[105] !== t15 || $[106] !== t16 || $[107] !== t18 || $[108] !== t26 || $[109] !== t28 || $[110] !== t33 || $[111] !== t34 || $[112] !== t36 || $[113] !== t49 || $[114] !== t51 || $[115] !== t53) {
    t54 = <div className="col-span-1 lg:col-span-4 px-4 md:px-0">{t15}{t16}{t18}{t26}{t28}{t33}{t34}{t36}{t49}{t51}{t53}</div>;
    $[105] = t15;
    $[106] = t16;
    $[107] = t18;
    $[108] = t26;
    $[109] = t28;
    $[110] = t33;
    $[111] = t34;
    $[112] = t36;
    $[113] = t49;
    $[114] = t51;
    $[115] = t53;
    $[116] = t54;
  } else {
    t54 = $[116];
  }
  let t55;
  if ($[117] !== t14 || $[118] !== t54) {
    t55 = <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 mt-8">{t14}{t54}</div>;
    $[117] = t14;
    $[118] = t54;
    $[119] = t55;
  } else {
    t55 = $[119];
  }
  let t56;
  if ($[120] !== accessories || $[121] !== loadingAccessories) {
    t56 = accessories.length > 0 && <FeaturedProducts products={accessories} isLoading={loadingAccessories} title="Dobierz do zestawu" smallTitle={true} productView={true} />;
    $[120] = accessories;
    $[121] = loadingAccessories;
    $[122] = t56;
  } else {
    t56 = $[122];
  }
  let t57;
  if ($[123] !== featuredProducts || $[124] !== loadingFeaturedProducts) {
    t57 = featuredProducts.length > 0 && <FeaturedProducts products={featuredProducts} isLoading={loadingFeaturedProducts} title="Polecane produkty" smallTitle={true} productView={true} />;
    $[123] = featuredProducts;
    $[124] = loadingFeaturedProducts;
    $[125] = t57;
  } else {
    t57 = $[125];
  }
  let t58;
  if ($[126] !== openSizeTableDrawer || $[127] !== setOpenSizeTableDrawer || $[128] !== sizeTableDrawer) {
    t58 = sizeTableDrawer && <SwipeableDrawer anchor="right" open={openSizeTableDrawer} onClose={() => setOpenSizeTableDrawer(false)} onOpen={() => setOpenSizeTableDrawer(true)}>{sizeTableDrawer}</SwipeableDrawer>;
    $[126] = openSizeTableDrawer;
    $[127] = setOpenSizeTableDrawer;
    $[128] = sizeTableDrawer;
    $[129] = t58;
  } else {
    t58 = $[129];
  }
  let t59;
  let t60;
  if ($[130] !== setOpenShopAvailabilityDrawer) {
    t59 = () => setOpenShopAvailabilityDrawer(false);
    t60 = () => setOpenShopAvailabilityDrawer(true);
    $[130] = setOpenShopAvailabilityDrawer;
    $[131] = t59;
    $[132] = t60;
  } else {
    t59 = $[131];
    t60 = $[132];
  }
  let t61;
  if ($[133] !== openShopAvailabilityDrawer || $[134] !== shopAvailabilityDrawer || $[135] !== t59 || $[136] !== t60) {
    t61 = <SwipeableDrawer anchor="right" open={openShopAvailabilityDrawer} onClose={t59} onOpen={t60}>{shopAvailabilityDrawer}</SwipeableDrawer>;
    $[133] = openShopAvailabilityDrawer;
    $[134] = shopAvailabilityDrawer;
    $[135] = t59;
    $[136] = t60;
    $[137] = t61;
  } else {
    t61 = $[137];
  }
  let t62;
  let t63;
  if ($[138] !== toggleUpdateCartModal) {
    t62 = () => toggleUpdateCartModal();
    t63 = () => toggleUpdateCartModal();
    $[138] = toggleUpdateCartModal;
    $[139] = t62;
    $[140] = t63;
  } else {
    t62 = $[139];
    t63 = $[140];
  }
  let t64;
  if ($[141] !== toggleUpdateCartModal) {
    t64 = <div className="absolute top-4 right-4"><Close className="w-6 h-6 cursor-pointer" onClick={() => toggleUpdateCartModal()} /></div>;
    $[141] = toggleUpdateCartModal;
    $[142] = t64;
  } else {
    t64 = $[142];
  }
  let t65;
  if ($[143] === Symbol.for("react.memo_cache_sentinel")) {
    t65 = <div className="flex flex-row gap-2 items-center"><Check color="success" className="w-10 h-10 -mt-[2px]" /><Text text={"Produkt zosta\u0142 dodany do koszyka"} /></div>;
    $[143] = t65;
  } else {
    t65 = $[143];
  }
  let t66;
  if ($[144] !== addedProduct) {
    t66 = addedProduct && <div className="flex flex-col my-8"><div className="flex flex-row gap-2 items-start"><div><Image src={addedProduct.imageUrl && addedProduct.imageUrl.replace("http://localhost/prestashop", "https://shop.carry.pl").replace("carry-prestashop.ulam.tech", "shop.carry.pl")} alt={addedProduct.name} width={60} height={90} /></div><div className="flex flex-col gap-2 py-2"><Text text={addedProduct.name} fontSize={TextSize.S} color={TextColor.GRAYSCALE_600} /><div className="flex items-center gap-2"><Text text={`Rozmiar: ${extractSize(addedProduct.attributesArray || addedProduct.attributes)} `} fontSize={TextSize.XS} color={TextColor.GRAYSCALE_500} /><Text text={"\u2022"} fontSize={TextSize.XS} color={TextColor.GRAYSCALE_500} /><Text text={`Kolor: ${extractColor(addedProduct.attributesArray || addedProduct.attributes)}`} fontSize={TextSize.XS} color={TextColor.GRAYSCALE_500} /></div></div></div></div>;
    $[144] = addedProduct;
    $[145] = t66;
  } else {
    t66 = $[145];
  }
  let t67;
  if ($[146] !== router || $[147] !== toggleUpdateCartModal) {
    t67 = <div className="flex flex-col gap-2"><Button text={"Przejd\u017A do koszyka"} variant={ButtonVariant.SECONDARY} className="!w-full" onClick={() => {
        router.push("/koszyk");
        toggleUpdateCartModal();
      }} /></div>;
    $[146] = router;
    $[147] = toggleUpdateCartModal;
    $[148] = t67;
  } else {
    t67 = $[148];
  }
  let t68;
  if ($[149] !== t64 || $[150] !== t66 || $[151] !== t67) {
    t68 = <div className="min-w-full md:max-w-[420px] p-4 relative">{t64}{t65}{t66}{t67}</div>;
    $[149] = t64;
    $[150] = t66;
    $[151] = t67;
    $[152] = t68;
  } else {
    t68 = $[152];
  }
  let t69;
  if ($[153] !== accessories || $[154] !== isMobile || $[155] !== toggleUpdateCartModal) {
    t69 = accessories.length > 0 && <div className="min-w-full md:max-w-[420px] p-4"><div className="w-full border-b border-gray-200 pb-2"><Text text="Dobierz do zestawu" weight={TextWeight.SEMIBOLD} color={TextColor.BLACK} fontSize={isMobile ? TextSize.S : TextSize.M} /></div><div className="grid grid-cols-2 gap-4 mt-10">{accessories.map(accessory => <ProductMiniature key={accessory.id} product={accessory} onClick={() => toggleUpdateCartModal()} />)}</div></div>;
    $[153] = accessories;
    $[154] = isMobile;
    $[155] = toggleUpdateCartModal;
    $[156] = t69;
  } else {
    t69 = $[156];
  }
  let t70;
  if ($[157] !== openUpdateCartModal || $[158] !== t62 || $[159] !== t63 || $[160] !== t68 || $[161] !== t69) {
    t70 = <SwipeableDrawer anchor="right" open={openUpdateCartModal} onClose={t62} onOpen={t63}>{t68}{t69}</SwipeableDrawer>;
    $[157] = openUpdateCartModal;
    $[158] = t62;
    $[159] = t63;
    $[160] = t68;
    $[161] = t69;
    $[162] = t70;
  } else {
    t70 = $[162];
  }
  let t71;
  if ($[163] !== t12 || $[164] !== t55 || $[165] !== t56 || $[166] !== t57 || $[167] !== t58 || $[168] !== t61 || $[169] !== t70) {
    t71 = <div className="w-full max-w-screen-2xl mx-auto pb-10 md:py-8">{t12}{t55}{t56}{t57}{t58}{t61}{t70}</div>;
    $[163] = t12;
    $[164] = t55;
    $[165] = t56;
    $[166] = t57;
    $[167] = t58;
    $[168] = t61;
    $[169] = t70;
    $[170] = t71;
  } else {
    t71 = $[170];
  }
  return t71;
};
const FormattedDescription = styled(Text)`
  color: ${({
  theme
}) => theme.colors.GRAYSCALE_600} !important;
  font-size: ${({
  theme
}) => theme.fontSizes.s} !important;

  div {
    line-height: 1.5;
  }
`;
const CopyWrapper = styled.div`
  position: relative;

  ${({
  theme,
  $before
}) => $before && `
     &:before {
   content: "";
   position: absolute;
   bottom: 0;
   left: 16px;
   width: calc(100% - 32px);
   height: 1px;
   background: ${theme.colors.GRAYSCALE_300};
 }`}

  ${({
  theme,
  $after
}) => $after && `
     &:after {
   content: "";
   position: absolute;
   top: 16px;
   right: 0;
   height: calc(100% - 32px);
   width: 1px;
   background: ${theme.colors.GRAYSCALE_300};
 }`}
`;
const StyledPriceWrapper = styled.div`
  p {
    padding-bottom: 0;
    margin: 0;
    line-height: 100%;
  }
`;
export default ProductPage;
function _temp(combination_1) {
  return {
    idProductAttribute: combination_1.idProductAttribute,
    size: extractSize(combination_1.attributes),
    quantity: combination_1.quantity,
    reference: combination_1.reference,
    color: combination_1.attributes.Kolor,
    price: combination_1.price,
    cover: combination_1.cover
  };
}
function _temp2(_, index) {
  return <div key={`size-skeleton-${index}`} className="w-12 h-10 border border-gray-200 bg-gray-200 animate-pulse" />;
}
function _temp3(label) {
  return <div key={label.title} className="px-2 py-1 w-fit" style={{
    color: label.color,
    backgroundColor: label.bgColor
  }}><Text text={label.title} fontSize={TextSize.S} /></div>;
}
function _temp4(size_0) {
  return size_0.quantity > 0;
}